import { LoadState } from "../../constants/enums";
import { IDndNumberData, IDndNumberDataState } from "./dnd-number.types";

export const defaultDndNumberData: IDndNumberData = {
    dnd_number_id: null,
    number: null,
    name: null,
    status: null,
    comment: null,
    create_dt: null,
    insert_dt: null,
};

export const DndNumberDataInitialState: IDndNumberDataState = {
    list: {
        data: [],
        totalRecords: 0,
        currentRecords: 0,
        currentPage: 1,
        itemsPerPage: 10,
        totalPages: 0,
        loading: LoadState.NotLoaded,
        error: null,
    },
    dndNumberData: {
        data: defaultDndNumberData,
        loading: LoadState.NotLoaded,
        error: null,
    },
};
